export default {
    search_name: "",
    data : "",
    selected_first_name: "",
    selected_last_name: "",
    report_no: "",
};
